import { useState } from "react";
import { Nav, Offcanvas, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "./Sidbar.css";
import { faMessage, faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullhorn,
  faGear,
  faTableCellsLarge,
  faHouse,
  faBars,
  faFileAlt,
  faPen,
  faChevronDown,
  faChevronUp,
  faGraduationCap,
  faBookBookmark,
  faCommentDots,
  faComments,
  faCoins,
  faMoneyBill,
  faTasks,
  faPercent,
} from "@fortawesome/free-solid-svg-icons";
import Logout from "../../../Pages/Auth/Logout";
import { icon } from "@fortawesome/fontawesome-svg-core";
import { FaTasks } from "react-icons/fa";

export default function Sidebar() {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [showContentMenu, setShowContentMenu] = useState(false);
  const [showMessagesMenu, setShowMessagesMenu] = useState(false);
  const [showTestsMenu, setShowTestsMenu] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navLinksMain = [
    { to: "/DashboardLayout", icon: faTableCellsLarge, label: "لوحة التحكم" },
  ];

  const contentSubMenu = [
    {
      to: "/DashboardLayout/content/academic",
      icon: faGraduationCap,
      label: "المراحل الدراسية",
    },
    {
      to: "/DashboardLayout/content/months",
      icon: faBookBookmark,
      label: "الشهور الدراسية",
    },
    {
      to: "/DashboardLayout/content/lessons",
      icon: faFileAlt,
      label: "الدروس",
    },
    {
      to: "/DashboardLayout/content/assignments",
      icon: faTasks,
      label: "الواجبات المرسلة",
    },
  ];

  const testsSubMenu = [
    {
      to: "/DashboardLayout/tests/create-test",
      icon: faFileAlt,
      label: "إنشاء اختبار",
    },
    {
      to: "/DashboardLayout/tests/create-full-exam",
      icon: faFileAlt,
      label: "إنشاء امتحان كامل",
    },
    {
      to: "/DashboardLayout/tests/create-question",
      icon: faPen,
      label: "إنشاء أسئلة",
    },
  ];

  const messagesSubMenu = [
    {
      to: "/DashboardLayout/messages/student-queries",
      icon: faCommentDots,
      label: "استفسارات الطلاب",
    },

    //1/ {
    //1/   to: "/DashboardLayout/messages/contact",
    //1/   icon: faComments,
    //1/   label: "رسائل التواصل",
    //1/ },
  ];

  const navLinksOther = [
    { to: "/DashboardLayout/users", icon: faUser, label: "المستخدمين" },
    { to: "/DashboardLayout/money", icon: faMoneyBill, label: "التحويلات" },
    { to: "/DashboardLayout/discounts", icon: faPercent, label: "خصومات الكورسات" },
    { to: "/DashboardLayout/ads", icon: faBullhorn, label: "الإعلانات" },
    //1/ { to: "/DashboardLayout/settings", icon: faGear, label: "الإعدادات" },
    { to: "/DashboardLayout/taskDashbord", icon: faTasks, label: "المهام" },
    { to: "/", icon: faHouse, label: "الصفحة الرئيسية" },
  ];

  const renderNavLinks = (links) =>
    links.map((link, index) => (
      <Nav.Link
        key={index}
        as={Link}
        to={link.to}
        onClick={handleClose}
        className={location.pathname === link.to ? "active" : ""}
      >
        <FontAwesomeIcon
          style={{ marginLeft: "10px" }}
          icon={link.icon}
          className="me-2"
        />
        {link.label}
      </Nav.Link>
    ));

  const DropdownMenu = ({ label, icon, isOpen, toggle, items }) => (
    <>
      <div
        className="content-menu-toggle"
        onClick={toggle}
        style={{ cursor: "pointer", padding: "10px 15px" }}
      >
        <FontAwesomeIcon
          style={{ marginLeft: "5px" }}
          icon={icon}
          className="me-2"
        />
        {label}
        <FontAwesomeIcon
          icon={isOpen ? faChevronUp : faChevronDown}
          style={{ float: "left", marginLeft: "5px" }}
        />
      </div>
      {isOpen && (
        <div style={{ paddingRight: "20px" }}>{renderNavLinks(items)}</div>
      )}
    </>
  );

  return (
    <>
      {/* زر الموبايل */}
      <Button
        variant="light"
        onClick={handleShow}
        className="d-md-none m-3"
        style={{ position: "fixed", top: 10, right: 10, zIndex: 1001 }}
      >
        <FontAwesomeIcon icon={faBars} />
      </Button>

      {/* Sidebar Desktop */}
      <div className="sidebar d-none d-md-block" dir="rtl">
        <h4>الرئيسي</h4>
        <Nav className="flex-column mb-4">
          {renderNavLinks(navLinksMain)}
          <DropdownMenu
            label="المحتوى"
            icon={faPen}
            isOpen={showContentMenu}
            toggle={() => setShowContentMenu((p) => !p)}
            items={contentSubMenu}
          />
          <DropdownMenu
            label="الاختبارات"
            icon={faGraduationCap}
            isOpen={showTestsMenu}
            toggle={() => setShowTestsMenu((p) => !p)}
            items={testsSubMenu}
          />

          <DropdownMenu
            label="الرسائل"
            icon={faMessage}
            isOpen={showMessagesMenu}
            toggle={() => setShowMessagesMenu((p) => !p)}
            items={messagesSubMenu}
          />
          {renderNavLinks(navLinksOther)}
        </Nav>

        <Nav.Link as="span">
          <Logout />
        </Nav.Link>
      </div>

      {/* Sidebar Mobile */}
      {/* زر الموبايل */}
      {!show && (
        <Button
          variant="light"
          onClick={() => setShow(true)}
          className="d-md-none m-3"
          style={{ position: "fixed", top: 10, right: 10, zIndex: 1050 }}
        >
          <FontAwesomeIcon icon={faBars} />
        </Button>
      )}
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        dir="rtl"
        className="sidebar" //1/ نفس الكلاس بتاع الديسكتوب
        style={{ width: "272px" }} //1/ عشان نضمن نفس العرض
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <h4 style={{ fontSize: "18px" }}>الرئيسي</h4>
          <Nav className="flex-column mb-3">
            {renderNavLinks(navLinksMain)}
            <DropdownMenu
              label="المحتوى"
              icon={faPen}
              isOpen={showContentMenu}
              toggle={() => setShowContentMenu((p) => !p)}
              items={contentSubMenu}
            />
            <DropdownMenu
              label="الاختبارات"
              icon={faGraduationCap}
              isOpen={showTestsMenu}
              toggle={() => setShowTestsMenu((p) => !p)}
              items={testsSubMenu}
            />

            <DropdownMenu
              label="الرسائل"
              icon={faMessage}
              isOpen={showMessagesMenu}
              toggle={() => setShowMessagesMenu((p) => !p)}
              items={messagesSubMenu}
            />
          </Nav>

          <h5 className="mt-4">أخرى</h5>
          <Nav className="flex-column">{renderNavLinks(navLinksOther)}</Nav>

          <div style={{ marginTop: "20px" }}>
            <Link style={{ fontSize: "18px", color: "#dc3545" }}>
              <Logout />
            </Link>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
